import React from "react";
import Typography from '@mui/material/Typography';

const About = () => {
    return (
        <Typography>
            About Us
        </Typography>

    );
  };

  export default About;